module.exports = __webpack_public_path__ + "static/sign-up-form-1-2-f08246d29496c8cf1d199e2c9f116303.png";